import * as React from 'react';
import clsx from 'clsx';
import leftArrow from '@/assets/images/svg/arrow.svg';

interface AuthCarouselControlsProps {
  activeSlide: number;
  onSlideChange: (index: number) => void;
  totalSlides: number;
}

export const AuthCarouselControls: React.FC<AuthCarouselControlsProps> = ({
  activeSlide,
  onSlideChange,
  totalSlides,
}) => {
  const handlePrev = () => {
    onSlideChange((activeSlide - 1 + totalSlides) % totalSlides);
  };

  const handleNext = () => {
    onSlideChange((activeSlide + 1) % totalSlides);
  };

  return (
    <div
      className={clsx(
        'absolute left-0 hidden w-full items-center justify-center gap-6 lg:flex',
        'top-[calc(100%+1.2rem)] short:top-[calc(100%+0.5rem)]'
      )}
    >
      {/* Left Arrow */}
      <button
        onClick={handlePrev}
        className='p-2 transition-opacity hover:opacity-70'
        aria-label='Previous slide'
        type='button'
      >
        <img src={leftArrow} alt='' className='size-6' />
      </button>

      {/* Dynamic Indicators */}
      <div className='flex gap-4'>
        {Array.from({ length: totalSlides }).map((_, index) => (
          <button
            key={index}
            onClick={() => onSlideChange(index)}
            className={clsx(
              'h-[7px] w-[70px] rounded-[22px] transition-colors duration-300',
              activeSlide === index ? 'bg-brand-300' : 'bg-gray-410'
            )}
            aria-label={`Go to slide ${index + 1}`}
            type='button'
          />
        ))}
      </div>

      {/* Right Arrow (Rotated) */}
      <button
        onClick={handleNext}
        className='p-2 transition-opacity hover:opacity-70'
        aria-label='Next slide'
        type='button'
      >
        <img src={leftArrow} alt='' className='size-6 rotate-180' />
      </button>
    </div>
  );
};
